/* eslint-disable react-hooks/exhaustive-deps */
import Dropdown from 'react-dropdown'
import React, { useState, useEffect } from 'react'

const Deductions = (props) => {

    const [ textMaker, setTextMaker ] = useState('none')
    const [ deductionType, setDeductionType ] = useState('selectMe')
    const [ deductionArea, setDeductionArea ] = useState(null)
    const [ deductionsList, setDeductionsList ] = useState([])
    const [ deductions, setDeductions ] = useState(0)
    const [ deductionComment, setDeductionComment ] = useState('')
    const [ list, setList ] = useState([])

    let myDeductionList = [
        'none',
        'HiVis',
        'Key Chain',
        'Fuel Card Charge',
        'Deduction'
    ]

    // map the deduction values
    const deductionValueMap = (dedType, dedValue) => {
        if (dedType === 'HiVis' || dedType === 'Key Chain') {
            return 5
        } else if (dedValue === 0) {
            return ''
        } else {
            return deductions
        }
    }
        // handle only allowing one
        useEffect( () => {
            props.deductionTrackerLocal(deductionType)
        }, [deductionType])

    // dropdown menu selection function
    const onSelectDeduction = (e) => {
        setDeductionType(e.value)
        setTextMaker(e.value)
    }

    // handle the input changes
    const handleChangeInputs = (e) => {
        let x = 0
        e.target.name === 'deductions' ? setDeductions(e.target.value) : x = x + 1
    }

    const handleDeductionComment = (e) => {
        setDeductionComment(e.target.value)
    }

    useEffect( () => {
        if (textMaker !== 'none') {
            setDeductionArea(
                <textarea onChange={handleDeductionComment} rows="4" cols="50" id='deduction_textarea'>
                    {deductionComment}
                </textarea>
            )
        } else {
            setDeductionArea(null)
        }
    }, [textMaker, deductionComment])

    useEffect( () => {
        props.dataEntered(deductionType, deductions, deductionComment, props.index)
    }, [deductionType, deductions, deductionComment])

    useEffect( () => {
        if (deductionType !== 'selectMe') {
            setList([])
        } else {
            setList(props.deductionListLocal)
        }
    }, [deductionType])

    return (
        <div className='dashboard_form_divs_texty'>    
            <div>
                <label className='dashboard_labels'>Deduction </label>        
            </div>
            <div className='solve_this'>
                <div>
                    <Dropdown 
                        options={list} 
                        onChange={onSelectDeduction} 
                        value={deductionType} 
                        placeholder="Select an option" 
                        className='drop_down_bar_dashboard'
                        id='drop_down_style'
                    />
                    <input className='input_dashboard_page' type="text" name='deductions' value={deductionValueMap(deductionType, deductions)} onChange={handleChangeInputs}/>
                    <div className='deductionsListOverall'>
                        {deductionArea}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Deductions
